var map = {
	"./icon-admin.svg": "a0fb",
	"./icon-bianji.svg": "843d",
	"./icon-config.svg": "37d4",
	"./icon-dangdifill.svg": "9251",
	"./icon-daohang.svg": "9c7c",
	"./icon-duanxin.svg": "4cdb",
	"./icon-editor.svg": "1547",
	"./icon-email.svg": "9367",
	"./icon-geren.svg": "2acd",
	"./icon-jiesuo.svg": "43cd",
	"./icon-job.svg": "368d",
	"./icon-log.svg": "fb5e",
	"./icon-menu.svg": "22ef",
	"./icon-mudedi.svg": "9e4c",
	"./icon-oss.svg": "fdcc",
	"./icon-pinglun.svg": "70a3",
	"./icon-role.svg": "e6a3",
	"./icon-shanchu.svg": "70b6",
	"./icon-shezhi.svg": "5439",
	"./icon-shoucang.svg": "911c",
	"./icon-shoucangfill.svg": "ebab",
	"./icon-shouye.svg": "c61b",
	"./icon-sousuo.svg": "c31a",
	"./icon-sql.svg": "40b2",
	"./icon-suoding.svg": "ed13",
	"./icon-system.svg": "03f9",
	"./icon-tixing.svg": "eb83",
	"./icon-tubiao.svg": "2367",
	"./icon-xiangqu.svg": "8d16",
	"./icon-xiangqufill.svg": "f89d",
	"./icon-zhedie.svg": "1687",
	"./icon-zonghe.svg": "2bde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2005";